<template>
  <div ref="reactionContainer" class="reaction__container">
    <slot></slot>
    <div v-if="showReactionOption && reactionIcons.length" class="reaction">
      <CReactionOption
        v-outside-click="{
          exclude: [],
          handler: closeReactions
        }"
        class="reaction__content"
        :class="{
          'reaction__content--active': reactionClicked
        }"
        @click="openReactionIcons"
      />
      <CReactionIcons
        v-if="reactionClicked"
        ref="reactionIcons"
        class="reaction__icons"
        :style="{ right: iconsRight, left: iconsLeft }"
        :icons="reactionIcons"
        :selected-icon="selectedIcon"
        @input="toggleReaction"
      />
    </div>
    <CReaction class="message__reaction" :reactions="reactions" />
  </div>
</template>
<script>
import { nextTick } from 'vue'

import Logger, { EventModel, EventName } from '@/wrappers/logger'

import { CReaction, CReactionIcons, CReactionOption } from '../../atoms'

export default {
  components: { CReactionOption, CReactionIcons, CReaction },
  props: {
    showReactionOption: {
      type: Boolean
    },
    reactions: {
      type: Array,
      default: () => []
    },
    userId: {
      type: String,
      required: true
    },
    reactionIcons: {
      type: Array,
      default: () => []
    }
  },
  emits: ['toggleReaction'],
  data() {
    return {
      reactionClicked: false,
      iconsRight: 'auto',
      iconsLeft: '-109px'
    }
  },
  computed: {
    selectedIcon() {
      return this.reactions?.find(reaction => reaction.userId === this.userId)
        ?.icon
    }
  },
  methods: {
    closeReactions() {
      this.reactionClicked = false
    },
    getReactionIconsPosition() {
      const containerBounding =
        this.$refs.reactionContainer.getBoundingClientRect()
      const iconsBounding = this.$refs.reactionIcons.$el.getBoundingClientRect()
      const endContainer = containerBounding.x + containerBounding.width
      const endIcons = iconsBounding.x + iconsBounding.width

      this.iconsRight = 'auto'
      this.iconsLeft = '-' + (iconsBounding.width / 2 - 20) + 'px'

      if (endContainer <= endIcons) {
        this.iconsRight = 0
        this.iconsLeft = 'auto'
      }
    },
    openReactionIcons() {
      Logger.addLog(EventName.USER_INTERACTION_MESSAGE, {
        model: EventModel.CHANNELS,
        data: {
          context: 'open_reaction_icons'
        }
      })
      this.reactionClicked = true
      nextTick(() => this.getReactionIconsPosition())
    },
    toggleReaction(icon) {
      this.$emit('toggleReaction', icon)
    }
  }
}
</script>
<style lang="scss" scoped>
.reaction__container {
  display: flex;
  align-items: center;
  position: relative;
  .reaction {
    position: relative;
    &__content {
      visibility: hidden;
    }
    &__icons {
      position: absolute;
      z-index: 4;
      top: -60px;
    }
  }

  &:hover .reaction__content,
  .reaction__content--active {
    visibility: visible;
  }
  .message__reaction {
    position: absolute;
    bottom: -22px;
    left: 0;
    z-index: 4;
  }
}
</style>
